import * as React from "react";
import { AbstractPlayer, SocialMentionSearch } from "@/components";
import { useMemo } from "react";
import { fullNameFrom, useSocialCoachSession } from "@/utils";
import { usePostFlowContext } from "../SharedPostFlowContext";

export function MentionsStep() {
  const { isPlayer } = useSocialCoachSession();
  const { mentions, addMention, removeMention, selectedPlayers, effectiveSocialNetworks } = usePostFlowContext();

  const abstractedPlayers: AbstractPlayer[] = useMemo(() => {
    return selectedPlayers.map(player => ({
      userId: player.info.userId,
      playerId: player.info.playerId!,
      name: fullNameFrom(player.info),
      photoUrl: player.info.photoUrl,
    }));
  }, [selectedPlayers]);

  return (
    <div className="flex flex-col gap-8 max-w-4xl mx-auto w-full">
      <SocialMentionSearch
        players={abstractedPlayers}
        mentions={mentions}
        networksFilter={isPlayer ? undefined : effectiveSocialNetworks}
        onAddMention={addMention}
        onRemoveMention={removeMention}
      />
    </div>
  );
}
